import PaymentInfoStep from "./PaymentInfoStep";

export default PaymentInfoStep;
